import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import BuildIcon from 'assets/build-icon.svg';
import {
  FormField,
  FormikInput,
  FormikSearchSelect,
  FormikSelect
} from 'components/UiKit/FormikFields';
import statesItems from 'components/AddressFields/StateSelect/data';
import formatPhoneNumber from 'screens/YieldV2/SaleLocations/helpers/formatPhoneNumber';
import { useFormikContext } from 'formik';

const ColumnWithFieldsRight = ({
  labelTitles,
  LabelInputs,
  divider,
  companies,
  isLoadingCompanies
}) => {
  const { values, setFieldValue } = useFormikContext();
  const [companyList, setCompanyList] = useState();
  const [phoneFormat, setPhoneFormat] = useState(
    formatPhoneNumber(values.phone ?? '')
  );

  useEffect(() => {
    // No blank first row: the search select clears with its own button.
    const arrayOfCompanies = [];
    // eslint-disable-next-line no-unused-expressions
    companies?.forEach(company =>
      arrayOfCompanies.push({
        value: company?.name,
        display: (
          <div className="flex flex-row items-center">
            <img
              src={BuildIcon}
              alt={company.name}
              style={{ width: '24px', marginRight: '8px' }}
            />
            {company?.name}
          </div>
        ),
        key: company?.id
      })
    );
    setCompanyList(arrayOfCompanies);
  }, [companies]);
  return (
    <div className="flex flex-col w-126 min-w-0">
      <div className="flex flex-row">
        <FormField label={labelTitles.phone} htmlFor={LabelInputs.phone}>
          <FormikInput
            id={LabelInputs.phone}
            name={LabelInputs.phone}
            value={phoneFormat}
            onChange={e => {
              setPhoneFormat(e.target.value);
            }}
            onBlur={e => {
              setPhoneFormat(formatPhoneNumber(e.target.value ?? ''));
              setFieldValue('phone', e.target.value);
            }}
          />
        </FormField>
        {divider('w-6')}
        <FormField label={labelTitles.company} htmlFor={LabelInputs.company}>
          <FormikSearchSelect
            id={LabelInputs.company}
            name={LabelInputs.companyId}
            label={labelTitles.company}
            items={companyList}
            placeholder={isLoadingCompanies ? '' : 'Loading...'}
            disabled={!isLoadingCompanies}
            searchableSelect
          />
        </FormField>
      </div>
      <FormField
        label={labelTitles.addressLineTwo}
        htmlFor={LabelInputs.addressLineTwo}
      >
        <FormikInput
          id={LabelInputs.addressLineTwo}
          name={LabelInputs.addressLineTwo}
        />
      </FormField>
      <div className="flex flex-row">
        <FormField label={labelTitles.State} htmlFor={LabelInputs.State}>
          <FormikSelect
            items={statesItems}
            id={LabelInputs.State}
            name={LabelInputs.State}
            placeholder="Select State"
          />
        </FormField>
        {divider('w-6')}
        <FormField label={labelTitles.zipCode} htmlFor={LabelInputs.zipCode}>
          <FormikInput id={LabelInputs.zipCode} name={LabelInputs.zipCode} />
        </FormField>
      </div>
    </div>
  );
};

ColumnWithFieldsRight.propTypes = {
  labelTitles: PropTypes.shape({
    phone: PropTypes.string.isRequired,
    company: PropTypes.string.isRequired,
    addressLineTwo: PropTypes.string.isRequired,
    zipCode: PropTypes.string.isRequired,
    State: PropTypes.string.isRequired
  }).isRequired,
  LabelInputs: PropTypes.shape({
    phone: PropTypes.string.isRequired,
    company: PropTypes.string.isRequired,
    companyId: PropTypes.string.isRequired,
    addressLineTwo: PropTypes.string.isRequired,
    zipCode: PropTypes.string.isRequired,
    State: PropTypes.string.isRequired
  }).isRequired,
  divider: PropTypes.func.isRequired,
  companies: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.number.isRequired,
      name: PropTypes.string.isRequired,
      svgUrl: PropTypes.string
    })
  ).isRequired,
  isLoadingCompanies: PropTypes.bool.isRequired
};

export default ColumnWithFieldsRight;
